import { getUrl } from 'helpers';
import styled from 'styled-components';

export const Base = styled.button`
    background-color: transparent;
    border: 0;
    color: #171716;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 700;
    height: 36px;
    line-height: 1;
    margin: 0;
    padding: 0;
`;

export const Contained = styled(Base)<AuthModalButtonContainedProps>`
    background: ${({ $alt }) => ($alt ? '#fff' : '#171716')};
    border-radius: 8px;
    border: 2px solid #171716;
    color: ${({ $alt }) => ($alt ? '#171716' : '#fff')};
    padding: 0 10px;

    &:active,
    &:focus,
    &:hover {
        box-shadow: rgba(0, 0, 0, 0.2) 0 2px 4px -1px, rgba(0, 0, 0, 0.14) 0 4px 5px 0, rgba(0, 0, 0, 0.12) 0 1px 10px 0;
    }
`;

export const Text = styled(Base)`
    min-width: 64px;
    outline: 0;
    position: relative;
    text-decoration: none;
    text-transform: none;
    transition: none;
    user-select: none;
    vertical-align: middle;

    &:after {
        background-image: url(${getUrl('/assets/underline.svg')});
        background-repeat: no-repeat;
        background-size: 100%;
        bottom: 3px;
        content: '';
        height: 5px;
        left: -2px;
        position: absolute;
        right: -2px;
    }
`;
